import styles from 'styles/layout/header.module.css';

export default function Header({ children }) {
  return <header>{children}</header>;
}
